import { SessionGuard } from "./SessionGuard";

/**
 * Admin (staff, non-instructor) pages. `seccion` requires that section's
 * `modulo` permission. The rules live in SessionGuard.
 */
export const PrivateRouter = ({ children, seccion }) => (
  <SessionGuard area="admin" seccion={seccion}>
    {children}
  </SessionGuard>
);
